module.exports = __webpack_public_path__ + "static/media/apartment23.376b51d5.jpg";